@use '@lib/assets/styles/main.scss' as *;
.actions {
  & > div + div {
    margin-top: 16px;
  }
}

.actionWrap {
  padding-left: 48px;
  position: relative;
  &::before {
    content: '';
    display: block;
    width: 1px;
    background: $gray100;
    position: absolute;
    top: 48px;
    left: 20px;
    bottom: -16px;
    transform: translateX(-50%);
  }
}

.actionIconWrap {
  position: absolute;
  top: 0;
  left: 0;
  padding: 4px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionItemIcon {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.actionItemIconBlue {
  background: $blueLight;
  color: $blue500;
}

.actionItemIconGreen {
  background: $greenLight;
  color: $success900;
}

.actionItemIconOrange {
  background: $orangeLight;
  color: $orange;
}

.actionItemIconViolet {
  background: $violetLight;
  color: $violet;
}

.pagination {
  padding: 12px 0 12px 24px;
}
